import { useRef } from "react";
import { gtmData5 } from "./data";
import "../assests/CSS/GtmComponent5.css";
import avtar from "../assests/images/avtar.png";
import avtar2 from "../assests/images/avtar2.png";
import gtmCurve from "../assests/images/gtm-curve.svg";
import gtmCurve_mobile from "../assests/images/gtm_curve_mobile.svg";

function GtmComponent5() {
  const card1Ref = useRef(null);
  const card4Ref = useRef(null);

  return (
    <div className="gtm5-container" style={{ position: "relative" }}>
      <div className="gtm5-heading-wrapper">
        <div className="gtm5-left">
          <h2>{gtmData5.title}</h2>
          <p className="desc">{gtmData5.description}</p>
          <p className="sub-desc">{gtmData5.subDescription}</p>
        </div>

        
        <div className="gtm5-right-1" ref={card1Ref}>
          <img className="gtm5-avtar-1" src={avtar} alt="avtar" />
          <div className="gtm5-card-group">
            <span className="gtm5-card-1">
              <p>{gtmData5.cards[0].text}</p>
            </span>
            <div className="gtm5-card-2">Mr. John</div>
          </div>
        </div>
      </div>

      
      <div className="gtm-right-2" ref={card4Ref}>
        <div className="gtm5-card3-avatar-wrapper">
          <div className="gtm5-card-3"><span className="gtm5-right-name">Mr. Batra</span></div>
          <img className="gtm5-avtar-2" src={avtar2} alt="avtar" />
        </div>
        <div className="gtm5-card-4">
          <p>{gtmData5.cards[1].text}</p>
        </div>
      </div>

      {/*  Desktop svg */}
      <img
        src={gtmCurve}
        alt="curve"
        className="gtm5-curve-img"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      />
      {/*  Mobile svg */}
            <img
        src={gtmCurve_mobile}
        alt="curve"
        className="gtm5-curve-img_mobile"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      />

      <button className="gtm5-btn">{gtmData5.buttonText}</button>
    </div>
  );
}

export default GtmComponent5;
